export function getLanguageFromCookie(cookieName = 'kgr_lang') {
    const match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
}

/**
 * The locale the current page was rendered in, e.g. `de_DE`.
 *
 * Prefers what the server resolved (partials/dynamic-js-bootstrap.html.twig) over the kgr_lang
 * cookie: the cookie is only one input of that resolution and the weakest one — it is absent for
 * anonymous visitors, it is not rewritten when LocaleListener derives the locale from the domain,
 * and it is dropped as a third-party cookie inside an iframe.
 *
 * @returns {string}
 */
export function getCurrentLocale() {
    return window.kgr?.locale?.current ?? getLanguageFromCookie() ?? 'de_DE';
}
